var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/shopping-cart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4 3.99976H6.66667L7.2 6.66642M9.33333 17.3331H22.6667L28 6.66642H7.2M9.33333 17.3331L7.2 6.66642M9.33333 17.3331L6.27614 20.3903C5.43619 21.2302 6.03108 22.6664 7.21895 22.6664H22.6667M22.6667 22.6664C21.1939 22.6664 20 23.8603 20 25.3331C20 26.8058 21.1939 27.9998 22.6667 27.9998C24.1394 27.9998 25.3333 26.8058 25.3333 25.3331C25.3333 23.8603 24.1394 22.6664 22.6667 22.6664ZM12 25.3331C12 26.8058 10.8061 27.9998 9.33333 27.9998C7.86057 27.9998 6.66667 26.8058 6.66667 25.3331C6.66667 23.8603 7.86057 22.6664 9.33333 22.6664C10.8061 22.6664 12 23.8603 12 25.3331Z",
    stroke: "#737791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/ShoppingCart.61c32c3f13541df667055729f16a84f6.svg";
export { ForwardRef as ReactComponent };